<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0" alignHorizontal="between">
                    <CCol md="5">
                        <!-- Filter -->
                        <SelectAsync
                            :label="$t('users')+':'"  
                            :placeholder="$t('--_select_an_option_--')"
                            :horizontal="{
                                label:'col-sm-3',
                                input:'col-sm-9',
                            }"

                            optionsValue='cognitoId'
                            optionsLabel='username'
                            endpoint='/account.api/users/summary?query=""'
                            :value.sync="userId"
                        />
                    </CCol>
                    <CCol md="5">
                        <FilterDate @updateData="updateData" :value.sync="actionDate" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <FilterFields
                            :fields="tables.userActionLogs.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="tables.userActionLogs.allFields"
                                        :activeFields.sync="tables.userActionLogs.fields"
                                    />
                                </div>
                                
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.userActionLogs.items"
                                    :fields="traslateLabels(tables.userActionLogs.fields)"
                                    
                                    :columnFilterValue.sync="tables.userActionLogs.columnFilterValue"
                                    items-per-page-select
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20, 50]
                                    }"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.userActionLogs.rows"
                                    v-bind="tables.userActionLogs"
                                >   
                                    <template #id="{index}">
                                        <td>
                                            {{ index + 1 }}
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <button
                                                class="m-2 p-0 btn-export-table"
                                                @click="downloadExportTable({
                                                    tableName: 'userActionLogs'
                                                })"
                                            >
                                                <span class="block-icon">
                                                    <CIcon  :content="$options.icons.cilDataTransferDown "/>
                                                </span>
                                                <span class="text">
                                                    {{ $t("export_to_csv") }}
                                                </span>
                                            </button>
                                        </div>
                                        
                                    </template>
                                </CDataTable>
                                
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.userActionLogs.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.userActionLogs.page"
                                    :pages="tables.userActionLogs.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import FilterDate from "~/components/FilterDate";
import { cilPlus, cilSettings, cilPencil, cilTrash, cilArrowThickFromRight } from '@coreui/icons';
import { mapGetters } from "vuex";
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table2.js';
import TableSettings from "£lement/TableSettings";
import UserActionLogsTable from "./Config/Tables/UserActionLogs.js";
import SelectAsync from "£lement/SelectAsync";
import FilterFields from "~/components/FilterFields";
export default {
    name: "UsersActivityPage",
    middleware: ["auth","page"],
    mixins: [ 
        pageMixin, 
        tableMixin 
    ],
    components:{
        FilterDate,
        TableSettings,
        SelectAsync,
        FilterFields
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight
    },
    data(){
        return {
            userId: null,
            actionDate:{
                from: null,
                to: null
            },
            tables:{
                userActionLogs: UserActionLogsTable
            }
        }
    },
    computed:{
        ...mapGetters({
            from:"filter/from",
            to:"filter/to"
        })

    },
    watch:{
        userId(newVal,oldVal){
            let _filter = {
                active: true,
                value: newVal,
                condition: "is_equal_to",
                expressionType: "condition"
            };
            let field = this.getTableField("userActionLogs", "userId");
            field._filter = _filter;
            this.setTableField("userActionLogs", "userId", field);
            this.updateData();
        },
        actionDate(newVal,oldVal){
            let _filter = {
                active: true,
                value: [newVal.from,newVal.to],
                condition: "between",
                expressionType: "filter"
            };
            let field = this.getTableField("userActionLogs", "date");
            field._filter = _filter;
            this.setTableField("userActionLogs", "date", field);
            this.updateData();
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.userActionLogs.rows = newValue;
            this.updatePagination(this.tables.userActionLogs.page);
        },
        updatePagination(newValue){
            this.tables.userActionLogs.page = newValue;
            this.updateData();
        },

        async updateData(){

            if(!this.userId){
                return false;
            }

            await this.updateTable({ 
                tableName: "userActionLogs",
                url: `/identity.api/users/actions/logs`,
            });

            this.$store.dispatch('page/updateLoading', {
                loading: false,
            });
        }
    },
    mounted(){
        // this.updateData();
        this.updatePageLoading(false);
        this.actionDate.from = this.from;
        this.actionDate.to = this.to;
    }
};
</script>

<style>
.button-filter {
    display: block;
    margin-right: 0;
    margin-left: auto;
}
</style>